import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  width: 975px;
`;

export const Form = styled.form`
  all: unset;
`;

export const Box = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
  margin-bottom: 8px;
`;

export const BtnGroup = styled.div`
  display: flex;
  margin: 24px 0 64px;
  gap: 16px;
`;

export const Head = styled.h2`
  padding: 32px 40px 0;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 16px;
`;
export const Field = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  align-items: baseline;
  align-items: center;
`;

export const Title = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const TextAriaField = styled.div`
  padding: 0 40px 16px;
  ${Title} {
    margin-bottom: 8px;
  }
`;

export const TextField = styled.p`
  margin-right: auto;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Footer = styled.div`
  margin-top: 32px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
    label,
    span {
      font-size: 12px;
      line-height: 16px;
      color: ${Palette.PrimaryGray._700};
    }
    label {
      font-weight: 500;
    }
    span {
      margin-bottom: 8px;
      font-weight: 400;
    }
  }
`;
